const envConfig = typeof window !== 'undefined' ? window.__ENVIRONMENT__ : undefined;

const ENV = envConfig?.ENV ?? 'eu';
const STAGE = envConfig?.STAGE ?? 'lab';
const VERSION = envConfig?.VERSION ?? '';
const CONFIG_BY_STAGE = envConfig?.CONFIG_BY_STAGE;

const stageConfig = CONFIG_BY_STAGE?.[STAGE];
const envDetails = stageConfig?.CONFIG_BY_ENV?.[ENV];

const API_HOST = envDetails?.API_HOST ?? '';
const KEYCLOAK_HOST = envDetails?.KEYCLOAK_HOST ?? '';
const AMPLITUDE_API_KEY = envDetails?.AMPLITUDE_API_KEY ?? '';

export { ENV, STAGE, VERSION, API_HOST, KEYCLOAK_HOST, AMPLITUDE_API_KEY };
